import { BrowserRouter as Router } from 'react-router-dom';
import { QueryClientProvider, QueryClient } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import {
  ChakraProvider,
  extendTheme,
  ColorModeScript,
  Input,
} from '@chakra-ui/react';
import { StepsTheme as Steps } from 'chakra-ui-steps';
import { MultiSelectTheme } from 'chakra-multiselect';

// import customTheme from '../theme';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      useErrorBoundary: false,
      refetchOnWindowFocus: false,
      retry(failureCount, error) {
        if (error.status === 404) return false;
        if (failureCount < 2) return true;
        return false;
      },
    },
  },
});

const theme = extendTheme({
  fonts: {
    heading: 'Poppins, sans-serif',
    body: 'Poppins, sans-serif',
  },
  components: {
    Steps,
    Input: {
      // sizes: 'sm',
      defaultProps: {
        size: 'md',
      },
    },
    Button: {
      // sizes: 'md',
      defaultProps: {
        size: 'md',
        bgColor: 'red.700',
      },
    },
    Select: {
      defaultProps: {
        size: 'md',
      },
    },
    MultiSelect: MultiSelectTheme,
    // Inp,
  },
  config: {
    initialColorMode: 'light',
  },
  styles: {
    global: {
      /* Headings */
      h1: {
        fontSize: '36px' /* Ukuran besar untuk h1 */,
        fontWeight: 'bold',
      },
      h2: {
        fontSize: '30px' /* Heading lebih kecil */,
        fontWeight: 'bold',
      },

      h3: {
        fontSize: '24px',
        fontWeight: 'bold',
      },

      h4: {
        fontSize: '20px',
        fontWeight: 'bold',
      },

      h5: {
        fontSize: '18px',
        fontWeight: 'bold',
      },

      h6: {
        fontSize: '16px',
        fontWeight: 'bold',
      },

      /* Paragraphs */
      p: {
        fontSize: '16px' /* Default ukuran teks paragraf */,
        lineHeight: 1.5,
      },
    },
  },
});

function AppProviders({ children }) {
  return (
    <QueryClientProvider client={queryClient}>
      <ColorModeScript initialColorMode={theme.config.initialColorMode} />
      <ChakraProvider resetCSS theme={theme}>
        <Router>{children}</Router>
      </ChakraProvider>
      <ReactQueryDevtools />
    </QueryClientProvider>
  );
}

export { AppProviders };
